export default theme => ({
  root: {
    margin: '0 0.2rem 0 0',
    minWidth: 'auto',
    boxShadow: theme.customShadows[1],
  },
});
